export const ALL_CATEGORIES = 'all'
